/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ max: NonNullable<unknown> }} Exclusion_Limit_ReachedInputs */

const en_us2_exclusion_limit_reached = /** @type {(inputs: Exclusion_Limit_ReachedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`You can exclude up to ${i?.max} exercises. Allow one back first.`)
};

const pt_br2_exclusion_limit_reached = /** @type {(inputs: Exclusion_Limit_ReachedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Você pode excluir até ${i?.max} exercícios. Libere um antes.`)
};

const es_419_exclusion_limit_reached = /** @type {(inputs: Exclusion_Limit_ReachedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Puedes excluir hasta ${i?.max} ejercicios. Libera uno primero.`)
};

const pt_pt2_exclusion_limit_reached = /** @type {(inputs: Exclusion_Limit_ReachedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Podes excluir até ${i?.max} exercícios. Liberta um primeiro.`)
};

const fr_fr2_exclusion_limit_reached = /** @type {(inputs: Exclusion_Limit_ReachedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tu peux exclure ${i?.max} exercices au maximum. Rétablis-en un d'abord.`)
};

const de_de2_exclusion_limit_reached = /** @type {(inputs: Exclusion_Limit_ReachedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Du kannst bis zu ${i?.max} Übungen ausschließen. Lass zuerst eine wieder zu.`)
};

const it_it2_exclusion_limit_reached = /** @type {(inputs: Exclusion_Limit_ReachedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Puoi escludere al massimo ${i?.max} esercizi. Riammettine uno prima.`)
};

/**
* | output |
* | --- |
* | "You can exclude up to {max} exercises. Allow one back first." |
*
* @param {Exclusion_Limit_ReachedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exclusion_limit_reached = /** @type {((inputs: Exclusion_Limit_ReachedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exclusion_Limit_ReachedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exclusion_limit_reached(inputs)
	if (locale === "es-419") return es_419_exclusion_limit_reached(inputs)
	if (locale === "pt-PT") return pt_pt2_exclusion_limit_reached(inputs)
	if (locale === "fr-FR") return fr_fr2_exclusion_limit_reached(inputs)
	if (locale === "de-DE") return de_de2_exclusion_limit_reached(inputs)
	if (locale === "it-IT") return it_it2_exclusion_limit_reached(inputs)
	return en_us2_exclusion_limit_reached(inputs)
});
export { exclusion_limit_reached as "exclusion.limit_reached" }